import { FC, memo } from 'react';
import { onLoginLogListItemModel } from 'Models';
import { TickIcon, AlertIcon } from 'Components';
import moment from 'moment';
import { useLocalization } from 'Hooks';

import './LogItem.scss';

type LogItemProps = {
  isLast: boolean;
};

const LogItem: FC<onLoginLogListItemModel & LogItemProps> = memo(({ InsertDate, LoginStatus, isLast }) => {
  const { web_successful_login, web_unsuccessful_login } = useLocalization();
  const date = moment(InsertDate).format('DD.MM.YYYY/HH:mm');
  const isSuccess = LoginStatus === 'Başarılı';
  const statusText = isSuccess ? web_successful_login : web_unsuccessful_login;

  return (
    <tr className={`loginLogItem${isLast ? ' loginLogItem--last' : ''}`}>
      <td className="loginLogItem__date">{date}</td>
      <td className={`loginLogItem__status loginLogItem__status--${isSuccess ? 'success' : 'fail'}`}>
        <span className="loginLogItem__status-icon" aria-hidden="true">
          {isSuccess ? <TickIcon /> : <AlertIcon />}
        </span>
        <span>{statusText}</span>
      </td>
    </tr>
  );
});
export default LogItem;
